// app/javascript/controllers/flash_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notification"]
  static values = {
    autoDismiss: { type: Boolean, default: true },
    delay: { type: Number, default: 5000 }
  }

  connect() {
    // Animation d'entrée
    setTimeout(() => {
      this.show()
    }, 100)

    // Auto-dismiss si activé
    if (this.autoDismissValue) {
      this.timeout = setTimeout(() => {
        this.dismiss()
      }, this.delayValue)
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  show() {
    this.notificationTarget.classList.remove("translate-x-[120%]", "opacity-0")
    this.notificationTarget.classList.add("translate-x-0", "opacity-100")
  }

  dismiss() {
    this.notificationTarget.classList.remove("translate-x-0", "opacity-100")
    this.notificationTarget.classList.add("translate-x-[120%]", "opacity-0")

    // Supprimer l'élément du DOM après l'animation
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.remove()
      }
    }, 500) // Durée de l'animation CSS
  }

  // Action pour le bouton close
  close() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.dismiss()
  }
}
